import { render, staticRenderFns } from "./Editormanage.vue?vue&type=template&id=15d1c5e6&scoped=true&"
import script from "./Editormanage.vue?vue&type=script&lang=js&"
export * from "./Editormanage.vue?vue&type=script&lang=js&"
import style0 from "./Editormanage.vue?vue&type=style&index=0&id=15d1c5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1c5e6",
  null
  
)

export default component.exports